module.exports = __webpack_public_path__ + "static/media/nosotros03.528cf619.jpg";